// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1eE8R","name":"Card_name__1qjZb","img":"Card_img__qr-qd"};